.controlCard {
	width: 354px;
	height: auto;
	padding: 20px;
    border-radius: 9px;
	background-color: var(--hps-white);
	box-shadow: 0 0 4px 1px rgba(0,0,0,0.1);
}
.titleContainer {
    min-height: 50px;
}
.descriptionContainer {
    min-height: 90px;
}
.effectivenessTextContainer {
	padding-top: 5px;
    text-align: center;
}
.horizontalLine {
	box-sizing: border-box;
	height: 1px;
	width: 354px;
    margin-left: -20px;
	border: 2px solid #1C4860;
	opacity: 0.07;
}
.linkContainer {
    padding-top: 20px;
	display: flex;
	justify-content: center;
}
